import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { HTMLAttributes } from 'react';

import { formatThousandSeparator } from '@/utils/formatters/formatThousandSeparator';
import { useIsMobileDevice } from '@/utils/useIsMobileDevice';

import type { DropdownItemBase } from '../../autocomplete.types';

import { autocompleteDropdownItemStyle as sx } from './AutocompleteDropdownItem.styles';

const MAX_LABEL_CHARS = 60;
const MAX_LABEL_CHARS_SMALL_DEVICE = 30;

type Props<T extends DropdownItemBase = DropdownItemBase> = {
	item: T;
	optionProps: HTMLAttributes<HTMLLIElement>;
};

export const AutocompleteDropdownItem = <
	T extends DropdownItemBase = DropdownItemBase
>({
	item,
	optionProps
}: Props<T>) => {
	const isMobileDevice = useIsMobileDevice();
	const { name, count: c } = item;
	const count = c !== undefined ? c : 0;

	const isLongName =
		name.length >
		(isMobileDevice ? MAX_LABEL_CHARS_SMALL_DEVICE : MAX_LABEL_CHARS);

	const Label = (
		<Typography sx={sx.label} noWrap>
			{name}
		</Typography>
	);

	return (
		<Box component='li' {...optionProps} sx={sx.root}>
			{isLongName ? (
				<Tooltip title={name} placement='top-start'>
					{Label}
				</Tooltip>
			) : (
				Label
			)}

			{count > 0 && (
				<Typography sx={sx.count}>
					({formatThousandSeparator(count)})
				</Typography>
			)}
		</Box>
	);
};
